import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const CTASection = () => {
  const scrollTo = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section data-testid="cta-section" className="py-20 md:py-28 bg-brand-teal relative overflow-hidden">
      <div className="absolute top-0 left-0 w-64 h-64 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full translate-x-1/3 translate-y-1/3" />
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white mb-6" data-testid="cta-title">Pronto para Escalar seus Resultados?</h2>
          <p className="text-base lg:text-lg text-white/80 max-w-2xl mx-auto mb-10">Nosso modelo já está provado. Temos clientes de peso e uma operação que dá resultados. Construa o próximo capítulo com a Duali Soluções.</p>
          <button onClick={() => scrollTo("#contato")} data-testid="cta-button"
            className="group inline-flex items-center gap-3 bg-white text-brand-navy px-10 py-4 rounded-md font-bold text-base hover:bg-brand-navy hover:text-white transition-all duration-300 hover:scale-105 hover:shadow-xl">
            Fale com um Especialista
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </motion.div>
      </div>
    </section>
  );
};
